import type { VideoBlockConfig } from '@lighthouse/core'
import { VideoFitType } from '@lighthouse/core'

/**
 * 生成视频block的配置
 *
 * @returns {VideoBlockConfig}
 */
export const generateVideoBlock = (mainBreakPoint: string): VideoBlockConfig => {
    return {
        ratio: '4',
        radius: '0',
        isLoop: true,
        isAuto: true,
        isMute: true,
        isUsedVideoControl: true,
        fitType: VideoFitType.auto,
        showLoading: true,
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            }
        },
        breakPoints: []
    }
}
